// extracted by mini-css-extract-plugin
export default {"singlePost":"SinglePost_singlePost__MSLvB","middle":"SinglePost_middle__41VJu"};